export const SEO_CONTENT = {
  educational: {
    topicsTitle: 'Mokymosi sritys',
    topicsIntro:
      'SmartPanda mokomieji žaidimai apima skirtingas mokymosi sritis. Vaikas gali rinktis užduotis pagal temą, o mokymasis vyksta per praktinę ir interaktyvią veiklą.',
    topics: [
      {
        title: 'Matematika',
        description:
          'Skaičiai, matematinės lygtys, trupmenos, daugyba, laikas, pinigai, geometrija ir loginės užduotys.',
        path: '/matematikos-zaidimai',
      },
      {
        title: 'Skaitymas',
        description:
          'Žodžiai, pasakojimai, teksto supratimas, veikėjai ir skaitymo užduotys.',
        path: '/skaitymo-zaidimai',
      },
      {
        title: 'Lietuvių kalba',
        description:
          'Raidės, skiemenys, žodžiai, sakiniai, balsės, priebalsės ir skyryba.',
        path: '/lietuviu-kalbos-zaidimai',
      },
      {
        title: 'Kalbos ir tarimo lavinimas',
        description:
          'Skiemenų, garsų, žodžių ir kalbinio dėmesio užduotys.',
        path: '/logopediniai-zaidimai',
      },
      {
        title: 'Gamtos mokslai',
        description:
          'Interaktyvios užduotys apie mokslą, gamtą, gyvūnus ir aplinką.',
      },
      {
        title: 'Istorija ir geografija',
        description:
          'Užduotys, padedančios tyrinėti pasaulį, geografiją ir istorines temas.',
      },
    ],
  },

  math: {
    topicsTitle: 'Matematikos mokymosi temos',
    topicsIntro:
      'Matematikos žaidimai gali padėti vaikui praktiškai kartoti skaičiavimą, matematines sąvokas ir loginį mąstymą.',
    topics: [
      {
        title: 'Skaičiai ir skaičiavimas',
        description:
          'Skaičių atpažinimas, palyginimas ir praktinės skaičiavimo užduotys.',
      },
      {
        title: 'Matematinės lygtys',
        description:
          'Interaktyvios lygčių ir matematinių veiksmų užduotys.',
      },
      {
        title: 'Daugyba',
        description:
          'Daugybos veiksmų praktika žaidybinėje aplinkoje.',
      },
      {
        title: 'Trupmenos',
        description:
          'Trupmenų supratimas naudojant vizualias ir interaktyvias užduotis.',
      },
      {
        title: 'Pinigai',
        description:
          'Praktinės užduotys, susijusios su pinigais ir kasdienėmis situacijomis.',
      },
      {
        title: 'Laikas',
        description:
          'Laikrodžio ir laiko suvokimo praktika.',
      },
      {
        title: 'Geometrija',
        description:
          'Figūrų ir erdvinio mąstymo užduotys.',
      },
      {
        title: 'Grafikai',
        description:
          'Duomenų ir grafikų supratimo užduotys.',
      },
      {
        title: 'Loginis mąstymas',
        description:
          'Galvosūkiai ir užduotys, kuriose reikia ieškoti sprendimo.',
      },
    ],
  },

  reading: {
    topicsTitle: 'Skaitymo mokymosi temos',
    topicsIntro:
      'Skaitymo žaidimuose vaikas gali aktyviai dirbti su žodžiais, sakiniais, pasakojimais ir teksto informacija.',
    topics: [
      {
        title: 'Žodžių atpažinimas',
        description:
          'Žodžių paieškos ir atpažinimo užduotys.',
      },
      {
        title: 'Žodynas',
        description:
          'Žodžių reikšmės ir kalbinio žodyno plėtimo užduotys.',
      },
      {
        title: 'Sakinių supratimas',
        description:
          'Žodžių ir sakinių dėliojimo bei supratimo užduotys.',
      },
      {
        title: 'Teksto supratimas',
        description:
          'Užduotys, kuriose reikia suprasti ir rasti informaciją tekste.',
      },
      {
        title: 'Pasakojimo seka',
        description:
          'Pasakojimo įvykių ir istorijos struktūros supratimas.',
      },
      {
        title: 'Veikėjai',
        description:
          'Pasakojimų veikėjų atpažinimo ir supratimo užduotys.',
      },
      {
        title: 'Skaitymo sklandumas',
        description:
          'Žaidybinės užduotys, skirtos skaitymo praktikai.',
      },
    ],
  },

  lithuanian: {
    topicsTitle: 'Lietuvių kalbos mokymosi temos',
    topicsIntro:
      'Lietuvių kalbos žaidimai leidžia praktiškai mokytis kalbos pagrindų: nuo raidžių ir skiemenų iki sakinių ir skyrybos.',
    topics: [
      {
        title: 'Abėcėlė ir raidės',
        description:
          'Raidžių atpažinimo ir abėcėlės pažinimo užduotys.',
      },
      {
        title: 'Skiemenys',
        description:
          'Skiemens struktūros ir žodžių skaidymo užduotys.',
      },
      {
        title: 'Žodžių sudarymas',
        description:
          'Žodžių dėliojimo ir kalbos struktūros užduotys.',
      },
      {
        title: 'Sakinių sudarymas',
        description:
          'Žodžių dėliojimas į prasmingus sakinius.',
      },
      {
        title: 'Balsės ir priebalsės',
        description:
          'Balsių ir priebalsių atpažinimo bei skyrimo užduotys.',
      },
      {
        title: 'Didžiosios raidės',
        description:
          'Didžiųjų raidžių naudojimo praktika.',
      },
      {
        title: 'Skyryba',
        description:
          'Interaktyvios skyrybos praktikos užduotys.',
      },
    ],
  },

  speech: {
    topicsTitle: 'Kalbos lavinimo temos',
    topicsIntro:
      'Šioje kategorijoje pateikiamos edukacinės kalbos ir tarimo praktikos užduotys. Jos nėra medicininė diagnostikos ar gydymo priemonė.',
    topics: [
      {
        title: 'Skiemenys',
        description:
          'Skiemens struktūros ir kalbos ritmo praktika.',
      },
      {
        title: 'Kalbos garsai',
        description:
          'Garsų atpažinimo ir skyrimo užduotys.',
      },
      {
        title: 'Garso vieta žodyje',
        description:
          'Užduotys, kuriose reikia nustatyti garso vietą žodyje.',
      },
      {
        title: 'Minimalios poros',
        description:
          'Panašiai skambančių žodžių ir garsų skyrimo užduotys.',
      },
      {
        title: 'Kalbinė atmintis',
        description:
          'Žodžių ir garsų atminties bei dėmesio užduotys.',
      },
    ],
  },
};

export function getSEOContent(category) {
  return SEO_CONTENT[category] || SEO_CONTENT.educational;
}
